<claims-maintenance-banner
  *ngIf="isMaintenanceBanner && maintenanceBannerParams()"
  [params]="maintenanceBannerParams()"
></claims-maintenance-banner>
<button (click)="backButtonClicked.emit()">
  <dgx-components-icon name="arrow-left"></dgx-components-icon>
  <p class="typog-body-bold link">{{ 'MMR.BACK' | translate }}</p>
</button>
<ng-container *ngIf="claims && address | async as address; else Loader">
  <section class="repair-booking-title">
    <h1 data-testid="mmr-page-title">
      {{ claims.item?.manufacturer | brandcase : upperCaseBrands }}
      {{
        claims.item?.manufacturer
          ? isRpcPresent()
            ? claims.item?.code_description
            : (claims.item?.code_description | lowercase)
          : (claims.item?.code_description | capitalcase)
      }}
    </h1>
    <p data-testid="mmr-page-subtitle">{{ subtitle | translate }}</p>
  </section>

  <section class="support-needs">
    <dgx-components-icon
      name="hands-holding-heart"
      class="gradient"
    ></dgx-components-icon>

    <section class="content">
      <a
        (click)="trackClick('Tell us your support needs')"
        [href]="supportNeedsLink"
      >
        <dgx-components-icon
          name="hands-holding-heart"
          class="gradient"
        ></dgx-components-icon>
        <span>Tell us your support needs</span>
        <dgx-components-icon name="arrow-right"></dgx-components-icon>
      </a>

      <p class="typog-body">
        Let us know what help you need. When you use our services, we'll support
        you as best we can.
      </p>
    </section>
  </section>

  <section *ngIf="claims" class="claim-details">
    <claims-athome-myaccount-manage-my-repair-claim-detail-container
      *ngIf="claims.repairAction !== 'NOT_VALID'"
      (cancelClaim)="cancelClaim.emit($event)"
      (createClaim)="createClaim.emit($event)"
      (rebookClaim)="rebookClaim.emit($event)"
      (trackClaim)="trackClaim.emit($event)"
      [address]="address"
      [claimDetails]="claims.openRepair"
      [email]="user?.email"
      [fullClaimsDetails]="claims"
      [lastUpdated]="lastUpdated"
      [isRPC]="isRPC"
      claimType="REPAIR"
      [isNewOrbitFlow]="isNewOrbitFlow"
    >
    </claims-athome-myaccount-manage-my-repair-claim-detail-container>

    <claims-athome-myaccount-manage-my-repair-claim-detail-container
      *ngIf="showServiceDetails"
      (cancelClaim)="cancelClaim.emit($event)"
      (createClaim)="createClaim.emit($event)"
      (rebookClaim)="rebookClaim.emit($event)"
      (trackClaim)="trackClaim.emit($event)"
      [address]="address"
      [claimDetails]="claims.openService"
      [email]="user?.email"
      [fullClaimsDetails]="claims"
      [lastUpdated]="lastUpdated"
      claimType="SERVICE"
      [isNewOrbitFlow]="isNewOrbitFlow"
    >
    </claims-athome-myaccount-manage-my-repair-claim-detail-container>
  </section>

  <claims-athome-myaccount-electrical-safety
    *ngIf="claims?.planCategoryCode === 'W' || claims?.planCategoryCode === 'B'"
  >
  </claims-athome-myaccount-electrical-safety>

  <ng-container *ngIf="isHistoryShow">
    <section
      *ngIf="appointmentsHistory; else HistoryLoader"
      class="appointments-history"
    >
      <claims-athome-myaccount-appointments-history
        [serviceIncluded]="showServiceDetails"
        [appointmentsHistory]="appointmentsHistory"
      ></claims-athome-myaccount-appointments-history>
    </section>
  </ng-container>

  <ng-template #HistoryLoader>
    <claims-athome-myaccount-appointments-history-loader>
    </claims-athome-myaccount-appointments-history-loader>
  </ng-template>

  <claims-smart-fix-banner
    *ngIf="smartFixBanner && isSmartFixHubEnabled"
    [smartFixBanner]="smartFixBanner"
    [claims]="claims"
    class="smart-fix-block"
  ></claims-smart-fix-banner>

  <section
    class="claim-details-faqs-block"
    [ngClass]="{ 'section-spacing': !appointmentsHistory }"
  >
    <span
      class="claim-details-faqs-block__title"
      [ngClass]="{ 'no-FAQs': faqs.length === 0 }"
    >
      <button
        class="see-all-faqs__link_button"
        (click)="trackClick('See more help and advice'); gotoFAQs()"
      >
        <p class="see-all-faqs__link">See more help and advice</p>
      </button>
      <dgx-components-icon
        class="see-all-faqs__icon"
        name="arrow-right"
      ></dgx-components-icon>
    </span>
    <dgx-components-accordion
      *ngIf="faqs"
      [panels]="faqs"
      class="claim-details-faqs-block__content"
      (toggle)="onAccordionToggled($event)"
    >
    </dgx-components-accordion>
  </section>
</ng-container>

<section class="view-plan-details">
  <dgx-components-link
    tabindex="0"
    class="view-plan-details__link"
    data-testid="view-plan-details"
    (click)="trackClick('View plan details'); viewDetails()"
    role="link"
  >
    {{ 'MMR.VIEW_PLAN' | translate }}
  </dgx-components-link>
  <dgx-components-icon name="arrow-right" size="md"></dgx-components-icon>
</section>

<ng-template #Loader>
  <claims-athome-myaccount-manage-my-repair-loading>
  </claims-athome-myaccount-manage-my-repair-loading>
</ng-template>
